import CatalogueItemModal from "components/CatalogueItemModal";
import {
  LuBuilding2,
  LuCheck,
  LuCircleAlert,
  LuShieldCheck,
  LuX,
} from "react-icons/lu";
import { formatAbn } from "utils/abn";
import "./supplierEligibilityDialog.css";

export default function SupplierEligibilityDialog({
  supplier,
  agreement,
  darkMode,
  onClose,
}) {
  const checks = [
    ["ABN present", /^\d{11}$/.test(String(supplier.abnNumber || "").replace(/\s/g, "")), "An 11 digit ABN is saved on the contact."],
    ["Registered for GST", supplier.gstRegistered === true, "GST registration is declared on the contact."],
    ["Not a large business", supplier.isLargeBusiness === false, "The supplier declared it is not a large business."],
    ["Not a government entity", supplier.isGovernmentEntity === false, "The supplier declared it is not a government entity."],
    ["Active signed RCTI agreement", agreement?.status === "active", "A signed, active agreement is required to issue an RCTI."],
  ];
  const passedCount = checks.filter(([, passed]) => passed).length;
  const isEligible = passedCount === checks.length;

  return (
    <CatalogueItemModal darkMode={darkMode} onClose={onClose}>
      <section
        className="rcti-eligibility-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="supplier-eligibility-title"
      >
        <header className="rcti-eligibility-header">
          <div className="rcti-eligibility-heading-icon"><LuShieldCheck aria-hidden="true" /></div>
          <div>
            <span className="rcti-eligibility-eyebrow">RCTI issue requirements</span>
            <h2 id="supplier-eligibility-title">Supplier eligibility</h2>
          </div>
          <button type="button" className="quotation-dialog-close-btn" aria-label="Close" onClick={onClose}>
            <LuX aria-hidden="true" />
          </button>
        </header>

        <div className="rcti-eligibility-content">
          <div className="rcti-eligibility-supplier">
            <div className="rcti-eligibility-business-icon"><LuBuilding2 aria-hidden="true" /></div>
            <div className="rcti-eligibility-supplier-identity">
              <strong>{supplier.companyName || supplier.name}</strong>
              <span>ABN {formatAbn(supplier.abnNumber) || "Not recorded"}</span>
            </div>
            <span className={`rcti-eligibility-status${isEligible ? " is-eligible" : " is-incomplete"}`}>
              {isEligible ? "Eligible" : `${passedCount} of ${checks.length} confirmed`}
            </span>
          </div>

          <div className={`rcti-eligibility-summary${isEligible ? " is-eligible" : " is-incomplete"}`} role="status">
            <span className="rcti-eligibility-summary-icon">
              {isEligible ? <LuCheck aria-hidden="true" /> : <LuCircleAlert aria-hidden="true" />}
            </span>
            <span>
              <strong>{isEligible ? "Ready to issue" : "Requirements to review"}</strong>
              <small>{isEligible
                ? "The saved supplier details and agreement meet the RCTI checks."
                : "Review the items below. Eligibility is checked again before issue."}</small>
            </span>
          </div>

          <h3 className="rcti-eligibility-section-title">Eligibility checks</h3>
          <ul className="rcti-eligibility-checks">
            {checks.map(([label, passed, detail]) => (
              <li key={label} className={`rcti-eligibility-check${passed ? " is-passed" : " is-pending"}`}>
                <span className="rcti-eligibility-check-icon" aria-label={passed ? "Passed" : "Needs review"}>
                  {passed ? <LuCheck aria-hidden="true" /> : <LuCircleAlert aria-hidden="true" />}
                </span>
                <span className="rcti-eligibility-check-copy">
                  <strong>{label}</strong>
                  <small>{passed ? detail : label === "Active signed RCTI agreement" && agreement?.status
                    ? `Agreement is ${agreement.status}. An active agreement is required.`
                    : label === "Not a government entity"
                      ? "Not a government entity — not confirmed"
                      : "Not confirmed in the saved supplier details."}</small>
                </span>
                <span className="rcti-eligibility-check-state">{passed ? "Confirmed" : "Review"}</span>
              </li>
            ))}
          </ul>
          <p className="rcti-eligibility-footnote">These checks use the saved supplier settings and agreement. They are checked again when an RCTI is issued.</p>
        </div>

        <footer className="rcti-eligibility-footer">
          <button type="button" className="quotation-modal-submit-btn" onClick={onClose}>Done</button>
        </footer>
      </section>
    </CatalogueItemModal>
  );
}
